import { deepMerge } from 'js/utils/Utils'

const defaults = {
  event: {
    wheel: 'onwheel' in document ? 'wheel' : 'mousewheel',
    keyDown: 'keydown',
    keyUp: 'keyup',
    touchMove: 'ontouchmove' in document ? 'touchmove' : 'click',
  },
  elementName: '#App',
  keyCode: [/* left: */ 37, /* up: */ 38, /* right: */ 39, /* down: */ 40, /* tab: */ 9, /* pageup: */ 33, /* pagedown: */ 34, /* home: */ 36, /* end: */ 35],
}

export default class ScreenLock {
  constructor(options = {}) {
    deepMerge(this, defaults, options)

    this._preventKey = this._preventKey.bind(this)
  }

  lock($element = document.querySelector(this.elementName)) {
    if ($element) {
      this.addStyle($element)
    }
    this.lockKeyEvent()
    this.lockScrollEvent()
  }

  unlock($element = document.querySelector(this.elementName)) {
    if ($element) {
      this.removeStyle($element)
    }
    this.unlockKeyEvent()
    this.unlockScrollEvent()
  }

  addStyle($element = document.querySelector(this.elementName)) {
    if (!$element) return

    Object.assign($element.style, {
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      overflow: 'clip',
    })
  }

  removeStyle($element = document.querySelector(this.elementName)) {
    if (!$element) return

    Object.assign($element.style, {
      position: '',
      width: '',
      height: '',
      top: '',
      left: '',
      overflow: '',
    })
  }

  lockKeyEvent() {
    window.addEventListener(this.event.keyDown, this._preventKey, false)
    window.addEventListener(this.event.keyUp, this._preventKey, false)
  }

  unlockKeyEvent() {
    window.removeEventListener(this.event.keyDown, this._preventKey)
    window.removeEventListener(this.event.keyUp, this._preventKey)
  }

  lockScrollEvent() {
    window.addEventListener(this.event.wheel, this._preventWheel, { passive: false })
    window.addEventListener(this.event.touchMove, this._preventWheel, { passive: false })
  }

  unlockScrollEvent() {
    window.removeEventListener(this.event.wheel, this._preventWheel)
    window.removeEventListener(this.event.touchMove, this._preventWheel, { passive: false })
  }

  _preventKey(e) {
    let keyCode = null

    if (e.keyCode) {
      keyCode = event.keyCode
    } else if (e.which) {
      keyCode = event.which
    }

    const currentKeyCode = this.keyCode.find((code) => {
      return code === keyCode
    })

    if (currentKeyCode) {
      e.preventDefault()
    }
  }

  _preventWheel(e) {
    if (e.cancelable) e.preventDefault()
  }
}